import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form as FormikForm } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/pro-regular-svg-icons/faEdit'

import { ActionPanel, Checkbox } from '@peracto/peracto-ui'

import * as S from './styled'

const Form = ({
    values = {},
    schema,
    onSubmit,
    onReset = () => {},
    children = [],
    infoPanel = false,
    showActionPanel = true,
    enableReinitialize = true,
    checkbox,
    ...props
}) => {
    children = React.Children.toArray(children)

    /* let menu = children
        .filter(child => child.type.displayName === Group.displayName)
        .filter(group => group.props.predicate())
        .map((group, i) => <S.Item key={i} href={'#' + group.props.id}>{group.props.name}</S.Item>); */

    const initialValues = values

    if (!!checkbox) {
        initialValues[checkbox.name] = checkbox?.checked || false
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={schema}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={onSubmit}
            onReset={onReset}
            enableReinitialize={enableReinitialize}
        >
            {form => {
                if (Object.keys(form.errors).length > 0) {
                    console.warn('Form Error:', form.errors)
                }
                return (
                    <FormikForm {...props}>
                        <div className="row">
                            <div className="col-12">
                                {showActionPanel && (
                                    <ActionPanel isVisible={form.dirty}>
                                        <p>
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                size="lg"
                                                className="!mx-2"
                                            />
                                            You've made changes to this form.
                                        </p>

                                        <div className="!flex !items-center">
                                            <button
                                                type="button"
                                                className="btn !mr-2"
                                                data-testid="reset-form"
                                                onClick={form.handleReset}
                                            >
                                                Reset
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                                data-testid="save-form"
                                                disabled={form.isSubmitting}
                                            >
                                                Save
                                            </button>

                                            {!!checkbox && (
                                                <Checkbox
                                                    name={checkbox?.name}
                                                    label={checkbox?.text}
                                                    actionPanel={true}
                                                />
                                            )}
                                        </div>
                                    </ActionPanel>
                                )}
                                {infoPanel && <S.InfoPanel>{infoPanel}</S.InfoPanel>}

                                {children.map(group => group)}
                            </div>
                        </div>
                    </FormikForm>
                )
            }}
        </Formik>
    )
}

Form.displayName = 'Form'

Form.propTypes = {
    values: PropTypes.object,
    schema: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node,
}

export default Form
